var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 100 125"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 34.6,
  r: 15.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.3 72c-1.8 4.4 1.4 9.3 6.2 9.3h37.8c4.8 0 8-4.9 6.2-9.3-4.7-11.2-14.2-18.8-25.1-18.8S29.9 60.8 25.3 72"
})));
export default SvgLogin;